import React, { useState } from 'react';
import ImageGridDialog from './ImageGridDialog';
import ImageGridPresenter from './ImageGridPresenter';
import { ImageGridProps } from '../types';

/**
 * @param files Array(fileId와 fileName이 있어야합니다.)
 * @param maxHeight number
 * @param borderRadius number
 */
const ImageGridContainer: React.FC<ImageGridProps> = ({
  files,
  maxHeight,
  borderRadius,
  label
}) => {
  const [open, setOpen] = useState(false);

  return (
    <React.Fragment>
      {open && (
        <ImageGridDialog
          open={open}
          onClose={() => setOpen(false)}
          files={files}
        />
      )}
      <ImageGridPresenter
        files={files}
        maxHeight={maxHeight}
        borderRadius={borderRadius}
        label={label}
        onOpen={() => setOpen(true)}
      />
    </React.Fragment>
  );
};
export default ImageGridContainer;
